import { render } from "./executions-reallocations-block.vue?vue&type=template&id=bd95eb6c&scoped=true"
import script from "./executions-reallocations-block.vue?vue&type=script&lang=js"
export * from "./executions-reallocations-block.vue?vue&type=script&lang=js"

import "./executions-reallocations-block.vue?vue&type=style&index=0&id=bd95eb6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd95eb6c"]])

export default __exports__